export const DRONE_VALUES = [
  { id: 1, drone: "Phantom Pro 4 Multispectral" },
  { id: 2, drone: "Phantom Pro 4 ver.2" },
  { id: 3, drone: "Phantom Pro 4" },
  { id: 4, drone: "Phantom 4" },
  { id: 5, drone: "Mavic Pro 2" },
  { id: 6, drone: "Parrot Anafi AI" }
];

export const FILE_TYPE_VALUES = [
  { uploadType: "single", fileType: "image/*" },
  { uploadType: "panorama", fileType: "image/*" },
  { uploadType: "video", fileType: "video/mp4" }
];